import React, {useState, useEffect} from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { faUserCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import axios from "axios";
import { API_URL } from "./Constants";
import {useDispatch, useSelector} from 'react-redux';
import {headerData} from '../../slices/headerSlice'
import { getUser } from "../../utils/api-services/user";
import HeaderDesktop from "./HeaderDesktop";
import HeaderMobile from "./HeaderMobile";
import HeaderSider from "./HeaderSider";

const Header = ({mode}) => {

    const [user, setUser] = useState(null);
    const [name, setName] = useState("......");
    const [loading, setLoading] = useState(false);
    const [width, setWidth] = useState(window.innerWidth);

    const headData = useSelector(headerData);
    const session = localStorage.getItem("session");
    let navigate = useNavigate();
    const isMobile = width <= 768;

    useEffect(()=>{
        loadUser();
    }, []);

    const loadUser = async ()=>{
        setLoading(true);
        const obj = await getUser();
        if(obj != null){
            setUser(obj);
            const name = isMobile? shortName(obj.Name): obj.Name;
            setName(name);
        }
        setLoading(false);
    }

    function shortName(name){
        return name.substring(0, 5);
    }

    let userNav = "";
    if(session && user){
        userNav = (
            <li className="nav-item dropdown">
                <a className="nav-link dropdown-toggle link-bold" href="#" id="navbardrop" data-toggle="dropdown">
                    {name}
                </a>
                <div className="dropdown-menu dropdown-menu-right">
                    <Link to="/profile" className="dropdown-item">Profile</Link>
                    <div className="dropdown-divider"></div>
                    <a href = "/user/logout" className="dropdown-item">Logout</a>
                </div>
            </li>
        )
    }else{
        userNav = (
            <li className="nav-item">
                <a href = "/user/sign-in/start" className="nav-link link-bold">
                    {isMobile? <FontAwesomeIcon icon={faUserCircle} className="link-icon" />: "Login | Sign Up"}
                </a>
            </li>
        )
    }

    return (
        <>

            {isMobile?
                <HeaderMobile userNav={userNav} mode={mode} />:
                <HeaderDesktop userNav={userNav} mode={mode} />
            }

            {headData.siderVisible && <HeaderSider />}

            <div style={{marginBottom:55}}></div>

        </>
    )

};

export default Header;